export default __webpack_public_path__ + "static/media/placeholder_store04-fr-web.0f5cef5d.png";